export const PRODUCT_SUCCESS = "PRODUCT_SUCCESS";
